// //---------------------------
import clsx from 'clsx'
import React, { FC, useState } from 'react'
import { Button, Modal } from 'react-bootstrap-v5'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
// import {HeaderNotificationsMenu, HeaderUserMenu, QuickLinks} from '../../../partials'
import { HeaderNotificationsMenu, HeaderUserMenu } from '../../../partials'

import { useLayout } from '../../core'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
  const { config } = useLayout()

  const [show, setShow] = useState(false);

  const handleClose = () => { setShow(false) };
  const handleShow = () => { if (show) { setShow(false) } else setShow(true) };

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* Search */}
      {/* <div className={clsx('d-flex align-items-stretch', toolbarButtonMarginClass)}>
        <Search />
      </div> */}
      {/* Activities */}
      {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}> */}
      {/* begin::Drawer toggle */}
      {/* <div
          className={clsx('btn btn-icon btn-active-light-primary', toolbarButtonHeightClass)}
          id='kt_activities_toggle'
        >
          <KTSVG
            path='/media/icons/duotune/general/gen032.svg'
            className={toolbarButtonIconSizeClass}
          />
        </div> */}
      {/* end::Drawer toggle */}
      {/* </div> */}
      {/* Quick links */}
      {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}> */}
      {/* begin::Menu wrapper */}
      {/* <div
          className={clsx('btn btn-icon btn-active-light-primary', toolbarButtonHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG
            path='/media/icons/duotune/general/gen025.svg'
            className={toolbarButtonIconSizeClass}
          />
        </div>
        <QuickLinks /> */}
      {/* end::Menu wrapper */}
      {/* </div> */}

      {/* CHAT */}
      {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}> */}
      {/* begin::Menu wrapper */}
      {/* <div
          className={clsx(
            'btn btn-icon btn-active-light-primary position-relative',
            toolbarButtonHeightClass
          )}
          id='kt_drawer_chat_toggle'
        >
          <KTSVG
            path='/media/icons/duotune/communication/com012.svg'
            className={toolbarButtonIconSizeClass}
          />

          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink'></span>
        </div> */}
      {/* end::Menu wrapper */}
      {/* </div> */}
      {/* NOTIFICATIONS */}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        {/* begin::Menu- wrapper */}
        <div
          className={clsx(
            'btn btn-icon btn-active-light-primary position-relative',
            toolbarButtonHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG
            path='/media/icons/duotune/general/gen022.svg'
            className={toolbarButtonIconSizeClass}
          />
        </div>
        {/* <HeaderNotificationsMenu /> */}
        {/* end::Menu wrapper */}
      </div>

      {/* NOTIFICATIONS */}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        {/* begin::Menu- wrapper */}
        <div
          className={clsx(
            'btn btn-icon btn-active-light-primary position-relative',
            toolbarButtonHeightClass
          )}
          onClick={handleShow}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          {/* <KTSVG */}
          {/* path='/media/avatars/blank.png' */}
          <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='UserImage'
            // className='w-100'

            className={`${toolbarButtonIconSizeClass} w-100`}
          />
          {/* /> */}
        </div>
        <HeaderNotificationsMenu />
        {/* end::Menu wrapper */}
      </div>

      {/* begin::User */}


      {/* <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button> */}
      {/* <div className="position-relative w-600px">
        <div className="position-absolute top-0 start-0">111</div>
        <div className="position-absolute top-0 end-0">222</div>
        <div className="position-absolute top-50 start-50">333</div>
        <div className="position-absolute bottom-50 end-50">444</div>
        <div className="position-absolute bottom-0 start-0">555</div>
        <div className="position-absolute bottom-0 end-0">666</div>
      </div> */}


      {/* <Modal show={show} onHide={handleClose}
          centered={false}
          backdrop={false}
          focus={false}
          className='menu-sub menu-sub-dropdown menu-row position-absolute start-100 end-0 w-200px h-200px'
          style={{ 'marginTop': '80px', 'overflow': 'hidden' , 'outline' : 'none', 'background-color': 'transparent', 'z-index':'-1' }}
          

        // style={
        //   {top:'5%',
        //   right:'10%',
        //   outline: 'none',
        //   overflow:'hidden',}
        // }
        // 
        >
          <Modal.Header >
            {/* <Modal.Title>Modal heading</Modal.Title> */}
      {/* </Modal.Header> */}
      {/* <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body> */}
      {/*
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleClose}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal> */}
      {/* <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      > */}
      {/* begin::Toggle */}
      {/* <div
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='UserImage' />
        </div> */}
      {/* <HeaderUserMenu /> */}
      {/* <HeaderNotificationsMenu /> */}

      {/* end::Toggle */}
      {/* </div> */}
      {/* end::User */}

      {/* begin::Aside Toggler */}
      {/* {config.header.left === 'menu' && (
        <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
          </div>
        </div>
      )} */}
    </div>
  )
}

export { Topbar }
